import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-hamburger',
  templateUrl: './icon-hamburger.component.html',
  styleUrls: ['./icon-hamburger.component.scss'],
  standalone: true,
})
export class IconHamburgerComponent {
  @Input() color = '#fff';
  @Input() width = '24';
  @Input() height = '24';
}
